import type { UseMutationResult } from 'react-query';
import { useMutation } from 'react-query';

import type {
  IApiCrowdNotifyRequestBody,
  IApiCrowdNotifyResponseBody,
} from '../CrowdApi.types';
import { useApi } from '~/lib/api/useApi';

export type IUseNotifyCrowdMutationValues = {
  appId: string;
  body: IApiCrowdNotifyRequestBody;
};

export const useNotifyCrowdMutation = (): UseMutationResult<
  IApiCrowdNotifyResponseBody,
  unknown,
  IUseNotifyCrowdMutationValues
> => {
  const api = useApi();

  return useMutation({
    mutationFn: (values) => api.crowd.notify(values.appId, values.body),
  });
};
